import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {
    ISchedaCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/ISchedaCosto";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";

const useApiGetSchedaCostoDetail = (order_id: number | undefined): UseQueryResult<ISchedaCosto, CustomAxiosError> => {
    const {get} = useApiCalls()
    const {selectedCompany} = useAuth()

    async function doGet(pk: number | undefined): Promise<ISchedaCosto> {
        try {

            const response = await get(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/schede_costo/by_order/${order_id}`);
            return response.data
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ['useApiGetSchedaCostoDetail', order_id],
        queryFn: () => doGet(order_id),
        enabled: !!order_id,
    })
};

export default useApiGetSchedaCostoDetail;
